
import CONQUER from "../CONQUER";
import ContactsX, { ContactX, FindOptions, ContactXError, ContactXPermissionResult} from 'cordova-plugin-contacts-x';

let CX: typeof ContactsX;
if (typeof window != 'undefined') {
    CX = require('cordova-plugin-contacts-x');
}

class Contacts
{
    private conquer : CONQUER;
    private hasPermission : boolean;
    private isRequesting : boolean;

    constructor( conquer:CONQUER )
    {
        this.conquer = conquer;
        this.hasPermission = false;
        this.isRequesting = true
    }

    public find() {
        if (typeof window != 'undefined') {
            if (!this.hasPermission) {
                this.isRequesting = true;
                CX.hasPermission(this.contactXHasPermissionResult, this.contactXError);
            } else {
                let options = {
                    fields: {
                        phoneNumbers: true
                    }
                };
                CX.find(this.contactXFind, this.contactXError, options);
            }
        }
    }

    private contactXHasPermissionResult (result:ContactXPermissionResult) {
        if (typeof window != 'undefined') {
            if (!result.read) {
                console.log(`[CONTACTS] hasPermission: false`);
                CX.requestPermission(this.contactXRequestPermissionResult, this.contactXError);
            }
        }
    }

    private contactXError (err:ContactXError) {
        console.log(`[CONTACTS] contactXError error: ${err.message}`);
    }

    private contactXRequestPermissionResult (result:ContactXPermissionResult) {
        if (typeof window != 'undefined') {
            this.hasPermission = result.read;
            if (this.isRequesting) {
                this.isRequesting = false;
                let options: FindOptions = {
                    fields: {
                        phoneNumbers: true
                    }
                };
                CX.find(this.contactXFind, this.contactXError, options);
            }
        }
    }

    private contactXFind(result: ContactX[]) {
        if (typeof window != 'undefined') {
            console.log(`[CONTACTS] found: ${result.length} contacts`);
            if (result.length > 0) {
                console.log(`[CONTACTS] 1st contact: ${JSON.stringify(result[0], null, 2)}`);
            }
        }
    }
}

export default Contacts;